/* ==========================================================================
   OBSIDIAN — Switch couleur Or / Titane (pages de collection)
   Bascule les vignettes vers l'image de la variante Couleur choisie et
   deep-link le lien vers ?variant=<id>.

   Garantie de robustesse (v4) : UN clic => TOUTES les cartes reflètent la
   couleur cible, immédiatement.
   - Le swap de src/srcset est TOUJOURS appliqué directement (synchrone) —
     jamais conditionné à un decode() ou à un préchargement.
   - Le crossfade est un BONUS, uniquement quand l'image cible est DÉJÀ
     décodée (préchargée) : sinon swap sec immédiat.
   - Token de génération : sur clics rapprochés, seul le dernier état écrit
     l'image ; les fondus obsolètes ne réécrivent plus rien.
   Chargé uniquement depuis sections/main-collection.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'obsidian-color-state';
  var DEFAULT_STATE = 'gold'; // état visuel initial du toggle (images par défaut = or)
  var STATES = ['gold', 'titane'];
  var VIEWPORT_MARGIN = 400; // px : marge autour du viewport pour tenter un crossfade

  var currentState = DEFAULT_STATE;
  var applied = false; // true dès qu'un swap a été appliqué (choix explicite ou persistant)
  var swapGen = 0;     // génération : seul le dernier clic peut écrire l'image réelle

  var idle = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 200); };

  function readStored() {
    try {
      var v = window.sessionStorage.getItem(STORAGE_KEY);
      return STATES.indexOf(v) !== -1 ? v : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(v) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, v);
    } catch (e) {
      /* sessionStorage indisponible : dégradation silencieuse */
    }
  }

  /* --- Mise à jour de l'UI du/des toggle(s) ------------------------------- */
  function syncToggleUI(state, animate) {
    var toggles = document.querySelectorAll('.obsidian-color-toggle');
    for (var t = 0; t < toggles.length; t++) {
      if (animate) toggles[t].classList.add('oc-animate');
      toggles[t].setAttribute('data-oc-active', state);
    }
    var btns = document.querySelectorAll('.obsidian-color-toggle__btn');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var isActive = btn.getAttribute('data-oc-state') === state;
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.classList.toggle('is-active', isActive);
    }
  }

  /* --- Préchargement des images d'un état (warm cache + décode) ----------- */
  /* On garde une réf de l'élément sur la carte (évite le GC qui annulerait le
     fetch) ET on s'en sert comme signal "prêt" + comme clone décodé. */
  function preloadState(state) {
    var cards = document.querySelectorAll('[data-obsidian-color-switch]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var src = card.getAttribute('data-oc-' + state + '-src');
      if (!src) continue;
      var ex = card['ocpre_' + state];
      if (ex && ex.getAttribute('src') === src && ex.complete && ex.naturalWidth > 0) continue;
      var srcset = card.getAttribute('data-oc-' + state + '-srcset') || '';
      var primary = card.querySelector('.product-card__image--primary');
      var pre = new Image();
      if (primary) pre.sizes = primary.getAttribute('sizes') || '';
      if (srcset) pre.srcset = srcset;
      pre.src = src; // sizes+srcset identiques => même candidat que l'affichage
      card['ocpre_' + state] = pre;
    }
  }

  /* --- Swap direct, garanti, synchrone ----------------------------------- */
  function instantSwap(img, src, srcset) {
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
    img.setAttribute('src', src);
  }

  /* --- Swap d'une carte : crossfade si l'image cible est déjà décodée,
         sinon swap sec immédiat. Dans TOUS les cas src/srcset est appliqué. */
  function swapCard(card, img, state, src, srcset, gen) {
    var link = img.closest('.product-card__media');
    var pre = card['ocpre_' + state];
    var ready = link &&
                pre &&
                pre.getAttribute('src') === src &&
                pre.complete &&
                pre.naturalWidth > 0;

    if (!ready) {
      // Pas prête (cache froid / préchargement pas fini) -> changement sec immédiat.
      instantSwap(img, src, srcset);
      return;
    }

    // Image prête : joli crossfade avec l'élément déjà décodé.
    card['ocpre_' + state] = null; // consommé
    var existing = link.querySelector('.obsidian-oc-clone');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var clone = pre;
    clone.className = img.className + ' obsidian-oc-clone';
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('draggable', 'false');
    clone.removeAttribute('loading');
    clone.removeAttribute('fetchpriority');
    clone.style.opacity = '0';
    link.appendChild(clone);

    var done = false;
    function commit() {
      if (done) return;
      done = true;
      window.clearTimeout(safety);
      if (gen === swapGen) instantSwap(img, src, srcset); // seul le dernier clic écrit
      if (clone.parentNode) clone.parentNode.removeChild(clone);
    }
    clone.addEventListener('transitionend', commit, { once: true });
    var safety = window.setTimeout(commit, 450); // filet si transitionend ne vient pas

    // L'image est déjà décodée : on lance le fondu tout de suite.
    requestAnimationFrame(function () {
      if (done || gen !== swapGen) { commit(); return; }
      clone.style.opacity = '1';
    });
  }

  /* --- Application d'un état à toutes les cartes -------------------------- */
  /* Phase 1 : lectures (liens + cible + visibilité). Phase 2 : écritures. */
  function applyState(state) {
    var gen = ++swapGen; // invalide les fondus des clics précédents
    var cards = document.querySelectorAll('[data-obsidian-color-switch]');
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var work = [];

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];

      var url = card.getAttribute('data-oc-' + state + '-url') ||
                card.getAttribute('data-oc-default-url');
      if (url) {
        var links = card.querySelectorAll('a.product-card__media, a.product-title');
        for (var j = 0; j < links.length; j++) links[j].setAttribute('href', url);
      }

      var img = card.querySelector('.product-card__image--primary');
      if (!img) continue;

      if (!card.hasAttribute('data-oc-orig-src')) {
        card.setAttribute('data-oc-orig-src', img.getAttribute('src') || '');
        card.setAttribute('data-oc-orig-srcset', img.getAttribute('srcset') || '');
      }

      var tSrc = card.getAttribute('data-oc-' + state + '-src');
      var tSrcset = card.getAttribute('data-oc-' + state + '-srcset') || '';
      if (!tSrc) { // couleur sans image -> image par défaut du thème
        tSrc = card.getAttribute('data-oc-orig-src') || '';
        tSrcset = card.getAttribute('data-oc-orig-srcset') || '';
      }
      if (!tSrc) continue;
      if (img.getAttribute('src') === tSrc) continue;

      var r = img.getBoundingClientRect();
      var near = r.bottom > -VIEWPORT_MARGIN && r.top < vh + VIEWPORT_MARGIN && r.width > 0;
      work.push({ card: card, img: img, src: tSrc, srcset: tSrcset, near: near });
    }

    for (var k = 0; k < work.length; k++) {
      var w = work[k];
      if (w.near) swapCard(w.card, w.img, state, w.src, w.srcset, gen);
      else instantSwap(w.img, w.src, w.srcset); // hors écran : swap sec, garanti
    }
  }

  /* --- Clic sur le toggle (délégation : survit aux re-render de facettes) -- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.obsidian-color-toggle__btn') : null;
    if (!btn) return;
    var state = btn.getAttribute('data-oc-state');
    if (STATES.indexOf(state) === -1) return;
    if (state === currentState && applied) return;

    currentState = state;
    applied = true;
    writeStored(state);

    syncToggleUI(state, true);   // feedback instantané (thumb + aria)
    applyState(state);           // swap garanti immédiat pour toutes les cartes
    idle(function () { preloadState(state === 'gold' ? 'titane' : 'gold'); }); // prépare le retour
  });

  /* --- Ré-application aux nouvelles cartes (pagination / facettes) -------- */
  function watchGrid() {
    var section = document.querySelector('.shopify-section--main-collection') ||
                  (document.getElementById('collection') || {}).parentNode;
    if (!section || !window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      if (scheduled) return;
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { relevant = true; break; }
      }
      if (!relevant) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncToggleUI(currentState, false);
        if (applied) applyState(currentState);
        idle(function () { preloadState(currentState === 'gold' ? 'titane' : 'gold'); });
      });
    });
    observer.observe(section, { childList: true, subtree: true });
  }

  /* --- Init -------------------------------------------------------------- */
  function init() {
    if (!document.querySelector('[data-obsidian-color-toggle]')) return;

    var stored = readStored();
    if (stored) {
      currentState = stored;
      applied = true;
      syncToggleUI(stored, false);
      applyState(stored);
    } else {
      currentState = DEFAULT_STATE;
      applied = false;
      syncToggleUI(DEFAULT_STATE, false); // « Or » présélectionné, aucun swap au 1er rendu
    }

    watchGrid();
    idle(function () { preloadState(currentState === 'gold' ? 'titane' : 'gold'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
